import React from "react";
import { ExclamationTriangleFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

const ServiceUnavailable = () => {
    const navigate = useNavigate();

    return (
        <div className="unknown-route-container">
            <div className="unknown-route-card">
                <div className="unknown-route-icon">⚠️</div>

                <h1 className="unknown-route-title">
                    Wrong path
                </h1>

                <div className="unknown-route-divider"></div>

                <p className="unknown-route-subtitle">
                    The requested page or service is unavailable, or the Path is incorrect.
                </p>

                {/* <button className="unknown-route-button">
                    Go to Home
                </button> */}
            </div>
        </div>
    );
};

export default ServiceUnavailable;